
@if (!showErrorsView) {
  <div>
    <div mat-dialog-title>Import Model Targets<button (click)="close()" class="close" mat-button title="Cancel"><i class="material-icons clear">clear</i></button></div>
    <mat-dialog-content>
      @if (hasFile && !isValidFile) {
        <mat-card class="error block">
          <mat-card-title class="error">Invalid file format.</mat-card-title>
          <mat-card-subtitle>Extension type must be ".csv"</mat-card-subtitle>
        </mat-card>
      }
      <div>
        <table class="import" width="100%">
          <tr>
            <th align="left" style="vertical-align: top;"><label>File name</label></th>
            <td>
              <div class="bottomPaddingElementDialog">
                <irb-file-selector (change)="onFileChange($event)"></irb-file-selector>
                <div>File type must be .csv</div>
              </div>
            </td>
          </tr>
          <tr>
            <th align="left" style="vertical-align: top;"><label>Instructions</label></th>
            <td>
              <div class="block">
                Use the below template to upload new security allocations for this model. Your selected file
                must be in .csv format and follow iRebal's format: Symbol and Target.
                <br>
                  Note: Target allocations can be entered up to one decimal place (ex: 10.5, not 10.55).
                </div>
              </td>
            </tr>
            <tr>
              <th align="left" style="vertical-align: top;"><label>Template</label></th>
              <td>
                <div>Use our .csv template to prepare your file.<br/>
                  <a href="/assets/template/ModelTargets_Import.xlsx" download>Download template:
                  ModelTargets_Import.xlsx</a></div>
                </td>
              </tr>
            </table>
          </div>
        </mat-dialog-content>
        <mat-dialog-actions>
          <button id="closeButton" (click)="close()" class="btn-medium-secondary">Cancel</button>
          <button id="continueButton" (click)="submitFile()" [disabled]="!(hasFile && isValidFile && !errorMessage)"
            class="btn-medium-primary">Continue
          </button>
        </mat-dialog-actions>
      </div>
    }

    @if (showErrorsView) {
      <div>
        <div mat-dialog-title>Securities Cannot Be Imported<button (click)="close()" class="close" mat-button title="Cancel"><i class="material-icons clear">clear</i></button></div>
        <mat-dialog-content>
          <div>
            <irb-inventory-grid id="mmc-securities-import-tragets-error-grid"
              [style.height]="erorGridHeight"
              [showSideBar]='false'
              [gridOptions]="gridOptions"
              [componentName]="'MmcImportModelTargetComponent'"
              [rowData]="errorRowData"
              >
            </irb-inventory-grid>
          </div>
        </mat-dialog-content>
        <mat-dialog-actions>
          <button id="cancelButton" (click)="close()" class="btn-medium-secondary">Cancel entire import</button>
        </mat-dialog-actions>
      </div>
    }
